// src/pages/Signup.js
import React from 'react';
import userIcon from '../assets/user.png';
import emailIcon from '../assets/email.png';
import lockedIcon from '../assets/locked.png';
import { Link } from 'react-router-dom';
import backgroundImage from '../assets/back.jpg';

const Signup = () => {
  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center px-4 py-12" style={{ fontFamily: 'var(--font-body)' }}>
      {/* Background photo, tied to the palette with a duotone overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center -z-10"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div
        className="absolute inset-0 -z-10"
        style={{ background: 'linear-gradient(160deg, rgba(22,38,43,0.85) 0%, rgba(14,124,123,0.55) 100%)' }}
      />

      <div className="bg-white/95 backdrop-blur-sm border border-[var(--mist)] shadow-xl p-8 rounded-3xl w-full max-w-md">
        <span
          className="block text-[var(--coral)] text-xs tracking-[0.2em] uppercase text-center mb-2"
          style={{ fontFamily: 'var(--font-mono)' }}
        >
          Join Drogastro
        </span>
        <h2
          className="text-3xl font-medium text-center text-[var(--ink)] mb-6"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          Sign Up
        </h2>

        <form id="form" action="/action_page.php" autoComplete="off" method="post">
          <div className="mb-6">
            <label htmlFor="username" className="block text-[var(--ink)] text-sm font-medium mb-2">Username</label>
            <div className="relative">
              <img src={userIcon} className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-60" alt="" />
              <input
                id="username"
                name="username"
                type="text"
                placeholder="username"
                required
                className="w-full pl-11 pr-4 py-2.5 border border-[var(--mist)] rounded-xl focus:outline-none focus:ring-2 focus:ring-[var(--teal)] transition-shadow"
              />
            </div>
            <div className="text-[var(--coral)] text-sm mt-1"></div>
          </div>

          <div className="mb-6">
            <label htmlFor="email" className="block text-[var(--ink)] text-sm font-medium mb-2">Email</label>
            <div className="relative">
              <img src={emailIcon} className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-60" alt="" />
              <input
                id="email"
                name="email"
                type="email"
                placeholder="name123@gmail.com"
                required
                className="w-full pl-11 pr-4 py-2.5 border border-[var(--mist)] rounded-xl focus:outline-none focus:ring-2 focus:ring-[var(--teal)] transition-shadow"
              />
            </div>
            <div className="text-[var(--coral)] text-sm mt-1"></div>
          </div>

          <div className="mb-6">
            <label htmlFor="password" className="block text-[var(--ink)] text-sm font-medium mb-2">Password</label>
            <div className="relative">
              <img src={lockedIcon} className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-60" alt="" />
              <input
                id="password"
                name="password"
                type="password"
                placeholder="············"
                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters and one or more of these special characters: .@$!%*#?&><)(^-_"
                required
                className="w-full pl-11 pr-4 py-2.5 border border-[var(--mist)] rounded-xl focus:outline-none focus:ring-2 focus:ring-[var(--teal)] transition-shadow"
              />
            </div>
            <div className="text-[var(--coral)] text-sm mt-1"></div>
          </div>

          <div className="mb-6">
            <label htmlFor="password2" className="block text-[var(--ink)] text-sm font-medium mb-2">Confirm Password</label>
            <div className="relative">
              <img src={lockedIcon} className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-60" alt="" />
              <input
                id="password2"
                name="password2"
                type="password"
                placeholder="············"
                pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters and one or more of these special characters: .@$!%*#?&><)(^-_"
                required
                className="w-full pl-11 pr-4 py-2.5 border border-[var(--mist)] rounded-xl focus:outline-none focus:ring-2 focus:ring-[var(--teal)] transition-shadow"
              />
            </div>
            <div className="text-[var(--coral)] text-sm mt-1"></div>
          </div>

          <button
            type="submit"
            className="w-full bg-[var(--teal)] hover:bg-[var(--teal-deep)] text-white font-medium py-2.5 px-4 rounded-full text-lg transition-colors duration-200"
          >
            Sign Up
          </button>

          <div className="text-center mt-4 text-[var(--ink)]/70 text-sm">
            Already a user?{' '}
            <Link to="/login" className="text-[var(--teal-deep)] font-medium hover:underline">Log in</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Signup;
